import { render, staticRenderFns } from "./LoginTitleComp.vue?vue&type=template&id=5af78b38&scoped=true&"
import script from "./LoginTitleComp.vue?vue&type=script&lang=ts&"
export * from "./LoginTitleComp.vue?vue&type=script&lang=ts&"
import style0 from "./LoginTitleComp.vue?vue&type=style&index=0&id=5af78b38&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5af78b38",
  null
  
)

export default component.exports